import React from "react";
import { makeStyles } from "@mui/styles";
import { fontSize, fontWeight, lineHeight } from "../../utils/constants/UI";

export const styles = makeStyles({
  micro: {
    fontSize: fontSize.MICRO,
    lineHeight: lineHeight.MICRO,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    // width: "inherit",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  xs: {
    fontSize: fontSize.XS,
    lineHeight: lineHeight.XS,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    // width: "inherit",
    // whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  sm: {
    fontSize: fontSize.SM,
    lineHeight: lineHeight.SM,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    // width: "inherit",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  md: {
    fontSize: fontSize.MD,
    lineHeight: lineHeight.MD,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    // width: "inherit",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  lg: {
    fontSize: fontSize.LG,
    lineHeight: lineHeight.LG,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    // width: "inherit",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  xl: {
    fontSize: fontSize.XL,
    lineHeight: lineHeight.XL,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    // width: "inherit",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  dxs: {
    fontSize: fontSize.DXS,
    lineHeight: lineHeight.DXS,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    // width: "inherit",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  dsm: {
    fontSize: fontSize.DSM,
    lineHeight: lineHeight.DSM,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    // width: "inherit",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  dlg: {
    fontSize: fontSize.DLG,
    lineHeight: lineHeight.DLG,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    // width: "inherit",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  dxl: {
    fontSize: fontSize.DXL,
    lineHeight: lineHeight.DXL,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    // width: "inherit",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

const Typography = ({ size, color, label, fontWeight, ...props }) => {
  const classes = styles({ color, fontWeight });
  return (
    <p className={classes[size]} {...props}>
      {label}
    </p>
  );
};

export default Typography;
